import React, { useEffect, useState } from 'react';

import { Stack, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FeatureTypography } from '../../components/Typography/FeatureTypography';

export const SelectedTransportLineDetails = ({ apiFeature, layerID, getFeatureInfoAttrs }) => {
  /**
     * component for general LineString type geometry of transport_line ID
     */

  const {t} = useTranslation();

  const [transportTitle, setTransportTitle] = useState(null);
  const [transportDepart, setTransportDepart] = useState(null);
  const [transportDest, setTransportDest] = useState(null);
  const [transportDir, setTransportDir] = useState(null);

  useEffect(() => {
    const featureTitleAttr = getFeatureInfoAttrs[layerID].title;
    const tempTitle = apiFeature.properties[featureTitleAttr];
    const title = tempTitle && tempTitle !== '' ? tempTitle: getFeatureInfoAttrs[layerID].defaultTitle;

    const stopDepartAttr = getFeatureInfoAttrs[layerID].point_depart;
    const tempStopDepart = apiFeature.properties[stopDepartAttr];
    const stopDepart = tempStopDepart && tempStopDepart !== '' ? tempStopDepart : '';

    const stopDestAttr = getFeatureInfoAttrs[layerID].point_arrive;
    const tempStopDest = apiFeature.properties[stopDestAttr];
    const stopDest = tempStopDest && tempStopDest !== '' ? tempStopDest : '';

    const transportDirAttr = getFeatureInfoAttrs[layerID].direction;
    const tempTransportDir =  apiFeature.properties[transportDirAttr];
    const transportDir = tempTransportDir && tempTransportDir !== '' ? tempTransportDir : '';

    setTransportTitle(title);
    setTransportDepart(stopDepart);
    setTransportDest(stopDest);
    setTransportDir(transportDir);
  }, [apiFeature, t]);

  return (
    <Stack sx={{ width: '100%', alignItems: 'center' }} direction='column' spacing={2}>
      <Box sx={{display: 'flex', width:'90%'}}>
        <FeatureTypography variant="h1" sx={{ width: '95%', fontSize: '1.2em', alignSelf:'center' }}>
          {apiFeature.properties.activite ? `${apiFeature.properties.activite}: ` : ''} {transportTitle} : {`${transportDepart} to ${transportDest}`}
        </FeatureTypography>
      </Box>
      <Box sx={{display: 'flex', width:'90%'}}>
        <FeatureTypography variant="h1" sx={{ width: '95%', fontSize: '1.2em', alignSelf:'center' }}>
          {transportDir}
        </FeatureTypography>
      </Box>
    </Stack>
  );
};